import React from "react";
import {
  ResetPasswordDesktopContainer,
  ResetPasswordDesktopColorBackground,
  ResetPasswordDesktopGradientLayer,
  ResetPasswordDesktopBrandPanel,
  ResetPasswordDesktopBrandLockup,
  ResetPasswordDesktopFormCell,
  ResetPasswordNonDesktopShell,
  ResetPasswordHeroBand,
  ResetPasswordHeroLockupImg,
  ResetPasswordNonDesktopContents,
} from "./ResetPassword.styles";
import unityLockup from "../../assets/logos/unity-rebrand/unity-vert-cobranded.svg";
import unityLockupHorizontal from "../../assets/logos/unity-rebrand/unity-horiz-cobranded.svg";
import { ResetPasswordSentContent } from "./ResetPasswordSentContent";
import { useDeviceHook } from "../../utils/hooks/useDeviceHook";

export const ResetPasswordSent = (): React.ReactElement => {
  const { isDesktop, deviceType } = useDeviceHook();

  return (
    <>
      {isDesktop && (
        <ResetPasswordDesktopContainer>
          <ResetPasswordDesktopColorBackground>
            <ResetPasswordDesktopGradientLayer aria-hidden />
            <ResetPasswordDesktopBrandPanel>
              <ResetPasswordDesktopBrandLockup
                src={unityLockup}
                alt="Unity by BillionToOne"
              />
            </ResetPasswordDesktopBrandPanel>
          </ResetPasswordDesktopColorBackground>
          <ResetPasswordDesktopFormCell>
            <ResetPasswordSentContent />
          </ResetPasswordDesktopFormCell>
        </ResetPasswordDesktopContainer>
      )}
      {!isDesktop && (
        <ResetPasswordNonDesktopShell>
          <ResetPasswordHeroBand $deviceType={deviceType}>
            <ResetPasswordHeroLockupImg
              $deviceType={deviceType}
              src={unityLockupHorizontal}
              alt="Unity by BillionToOne"
            />
          </ResetPasswordHeroBand>
          <ResetPasswordNonDesktopContents $deviceType={deviceType}>
            <ResetPasswordSentContent />
          </ResetPasswordNonDesktopContents>
        </ResetPasswordNonDesktopShell>
      )}
    </>
  );
};
